<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/authStore'

onMounted(() => {
  // Guard: if selectedPackageId points to a provider not in integrations, clear it
  // to prevent stale selection from causing API key lookup failures.
  // This runs after pinia-plugin-persistedstate rehydrates the store.
  const auth = useAuthStore()
  const prov = auth.selectedPackageId?.toUpperCase()
  if (prov && !auth.integrations[prov]) {
    auth.clearSelectedPackage()
  }
})
</script>
